'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _button = require('./styled/button');

var _button2 = _interopRequireDefault(_button);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BaseButton = function BaseButton(_ref) {
  var disabled = _ref.disabled,
      label = _ref.label,
      formSubmitAttributes = _ref.formSubmitAttributes,
      onClick = _ref.onClick,
      primary = _ref.primary,
      type = _ref.type;
  return _react2.default.createElement(
    _button2.default,
    (0, _extends3.default)({
      disabled: disabled ? 'disabled' : null,
      primary: primary
    }, formSubmitAttributes, {
      onClick: onClick,
      type: type,
      className: 'hrw-button'
    }),
    label
  );
};

BaseButton.propTypes = {
  disabled: _propTypes2.default.bool,
  formSubmitAttributes: _propTypes2.default.arrayOf(_propTypes2.default.string),
  label: _propTypes2.default.string,
  primary: _propTypes2.default.bool,
  onClick: _propTypes2.default.func,
  type: _propTypes2.default.string
};

BaseButton.defaultProps = {
  disabled: null,
  formSubmitAttributes: [],
  label: '',
  primary: true,
  onClick: function onClick() {},
  type: 'button'
};

exports.default = BaseButton;